import { useBackend } from "../../services";

export const useGetCollectionProducts = () => {
  const { get } = useBackend();
  const getCollectionProducts = () => get("products/collections");
  return { getCollectionProducts };
};
